import React from 'react'
import ReactDOM from 'react-dom/client'
import './i18n'
import '@tameeni/shared-logic/theme.styles.css'
import '@tameeni/shared-logic/theme-variables.css'
import '@/styles/globals.css'
import App from './App'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
